// extracted by mini-css-extract-plugin
export default {"modalContent":"modalContent__Cr81n","currentPdf":"currentPdf__dE27i","button":"button__ORmKD","updatePdf":"updatePdf__pnoKR"};